import styled, { createGlobalStyle } from "styled-components";

export const CustomGenericListStyle = createGlobalStyle`
  #main-content {
    overflow: hidden;
  }
`;

export const MainWrapper = styled.div`
  padding-inline: 50px;
  display: flex;
  flex-direction: column;
  height: calc(100dvh - 100px);
  overflow: hidden;
`;

export const HeaderFiltersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  min-height: 0;
  position: relative;
`;

export const WorkspacesContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px 0;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const WorkspacesGridWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding-right: 8px;

  @media (min-width: 1200px) {
    & > * {
      flex: 0 0 calc((100% - 24px) / 3);
    }
  }

  @media (min-width: 769px) and (max-width: 1199px) {
    & > * {
      flex: 0 0 calc(50% - 6px);
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    & > * {
      flex: 0 0 100%;
    }
  }
`;

export const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
`;

export const PaginationContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 12px 0;
  background: ${props => props.theme.colors.background || '#ffffff'};
  position: sticky;
  bottom: 0;
  z-index: 10;
`;

export const NoDataWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 60px 20px;
`;

export const NoDataTitle = styled.h3`
  font-size: 24px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.text};
  margin: 0;
`;

export const NoDataDescription = styled.p`
  font-size: 16px;
  color: ${(props) => props.theme.colors.textSecondary};
  margin: 0;
  text-align: center;
`;

